module.exports = __webpack_public_path__ + "img/Jeong Jeong-256.316abbe1.png";